import React, { useState } from 'react';
import type { CRB } from '@gcv/shared';

import { BusinessesModal } from './businesses-modal';
import { LicenseFoundSuccessModal } from './license-found-success-modal';
import { LicenseNotFoundConfirmationModal } from './license-not-found-confirmation-modal';
import { LicensesByBusinessModal } from './licenses-by-business-modal';
import { LicensesModal } from './licenses-modal';

interface BusinessLicensesWorkflowModalsProps {
  dispensary: CRB;
  resetModal: () => void;
  updateFileData: () => Promise<void>;
  setSelectedLicense: (data: { licenseId?: string; businessId?: string }) => void;
  licenseNumber: string;
}

export const BusinessLicensesWorkflowModals: React.FC<BusinessLicensesWorkflowModalsProps> = (props) => {
  const [licensesModalOpen, setLicensesModalOpen] = useState(true);
  const [businessesModalOpen, setBusinessesModalOpen] = useState(false);
  const [businessLicensesModalOpen, setBusinessLicensesModalOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  const [selectedBusiness, setSelectedBusiness] = useState('');

  const { dispensary, resetModal, updateFileData, setSelectedLicense, licenseNumber } = props;

  return (
    <>
      <LicensesModal
        isOpen={licensesModalOpen}
        onClose={resetModal}
        onSubmit={(
          selectedLicense?: { licenseId: string; businessId: string },
          licenseNotFound?: boolean
        ) => {
          if (licenseNotFound) {
            setBusinessesModalOpen(true);
          } else if (selectedLicense) {
            setSelectedLicense(selectedLicense);
            setSuccessModalOpen(true);
          }

          setLicensesModalOpen(false);
        }}
        onCancel={resetModal}
        dispensary={dispensary}
        licenseNumber={licenseNumber}
      />

      <BusinessesModal
        isOpen={businessesModalOpen}
        onSubmit={(selectedBusiness?: string, businessNotFound?: boolean) => {
          setBusinessesModalOpen(false);

          if (businessNotFound) {
            setErrorModalOpen(true);
          } else if (selectedBusiness) {
            setSelectedBusiness(selectedBusiness);
            setSelectedLicense({ businessId: selectedBusiness });
            setBusinessLicensesModalOpen(true);
          }
        }}
        onClose={resetModal}
        onCancel={() => {
          setBusinessesModalOpen(false);
          setLicensesModalOpen(true);
        }}
        dispensary={dispensary}
      />

      <LicensesByBusinessModal
        isOpen={businessLicensesModalOpen}
        onClose={resetModal}
        onSubmit={(
          selectedLicense?: { licenseId: string; businessId: string },
          licenseNotFound?: boolean
        ) => {
          setBusinessLicensesModalOpen(false);

          if (licenseNotFound) {
            setErrorModalOpen(true);
          } else if (selectedLicense) {
            setSelectedLicense(selectedLicense);
            setSuccessModalOpen(true);
          }
        }}
        onCancel={() => {
          setBusinessLicensesModalOpen(false);
          setBusinessesModalOpen(true);
        }}
        selectedBusiness={selectedBusiness}
      />

      <LicenseFoundSuccessModal
        isOpen={successModalOpen}
        onClose={resetModal}
        onSubmit={async () => {
          setSuccessModalOpen(false);
          await updateFileData();
        }}
      />

      <LicenseNotFoundConfirmationModal
        isOpen={errorModalOpen}
        onClose={resetModal}
        onSubmit={async () => {
          setErrorModalOpen(false);
          await updateFileData();
        }}
      />
    </>
  );
};
